import { GetAllInstitutionQuery } from 'api/institutions/dtos/get-all-institution.query.dto';
import { getAllInstitution } from 'api/institutions/institution.api';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import { create } from 'zustand';


const permissoesGetAll = [
    UserPermissionEnum.ADMIN,
    UserPermissionEnum.STATE_MANAGER,
]

export interface Address {
    zipcode: string
    state: string
    municipality: string
    district: string
    street: string
    number: string
    complement: string
}

export interface ContactList {
    uuid: string
    type: string
    value: string
}

export interface Profile {
    uuid: string
    description: any
    name: string
    group: Group
}

export interface Group {
    uuid: string
    name: string
    description: any
}

export interface IInstitution {
    uuid: string
    caf: string
    email: string
    fantasyName: string
    identification: string
    name: string
    isRegisterActive: boolean
    isRegisterBlocked: boolean
    address: Address
    contactList: ContactList[]
    profile: Profile
}

export interface Info {
    count: number
    page: number
    take: number
}


export interface IInstitutionStore {
    institution: IInstitution[];
    infoInstitution: Info;
    setInstitution: (institutions: IInstitution[]) => void;
    getInstitution: (
        filters?: Partial<GetAllInstitutionQuery>,
        position?: string,
    ) => Promise<void>;
}

export const useInstitutionStore = create<IInstitutionStore>((set) => ({
    institution: [],
    infoInstitution: {
        count: 0,
        page: 0,
        take: 0,
    },
    setInstitution: (institutions: IInstitution[]) => set({ institution: institutions }),
    getInstitution: async (
        filters?: Partial<GetAllInstitutionQuery>,
        permissionName?: string,
    ) => {
        const result =
            permissoesGetAll.includes(permissionName as UserPermissionEnum)
                ? await getAllInstitution(filters)
                : await getAllInstitution({
                    ...filters,
                    page: filters?.page ?? '1',
                    take: filters?.take ?? '10',
                    sortBy: 'created_at',
                    //profileUuid: profileUuid ?? '',
                });
        console.log('resultss', result);
        set({ institution: result.data as unknown as IInstitution[] });
        set({ infoInstitution: result.info as unknown as Info });
    }
}))